"use strict";

var _interopRequireWildcard = require("/mnt/data/websites/erp-vue/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/mnt/data/websites/erp-vue/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.regexp.match");
require("core-js/modules/es6.regexp.replace");
var _classCallCheck2 = _interopRequireDefault(require("/mnt/data/websites/erp-vue/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/mnt/data/websites/erp-vue/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.to-string");
require("/mnt/data/websites/erp-vue/node_modules/core-js/modules/es6.array.iterator.js");
require("/mnt/data/websites/erp-vue/node_modules/core-js/modules/es6.promise.js");
require("/mnt/data/websites/erp-vue/node_modules/core-js/modules/es6.object.assign.js");
require("/mnt/data/websites/erp-vue/node_modules/core-js/modules/es7.promise.finally.js");
var _vue = _interopRequireDefault(require("vue"));
var _auth = require("@/utils/auth");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
require("normalize.css/normalize.css");
var _elementUi = _interopRequireWildcard(require("element-ui"));
require("./assets/styles/element-variables.scss");
var _downloadjs = _interopRequireDefault(require("downloadjs"));
require("@/assets/styles/index.scss");
require("@/assets/styles/ruoyi.scss");
require("@/assets/styles/mgpd.scss");
require("@/assets/styles/flex.scss");
var _App = _interopRequireDefault(require("./App"));
var _store = _interopRequireDefault(require("./store"));
var _router = _interopRequireDefault(require("./router"));
var _permission = _interopRequireDefault(require("./directive/permission"));
require("./assets/icons");
require("./permission");
var _data = require("@/api/system/dict/data");
var _config = require("@/api/system/config");
var _ruoyi2 = require("@/utils/ruoyi");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vueElementUtils = _interopRequireDefault(require("vue-element-utils"));
var _moment = _interopRequireDefault(require("moment"));
var _plugins = _interopRequireDefault(require("./plugins"));
var _elDragDialog = _interopRequireDefault(require("@/directive/el-drag-dialog"));
require("@/directive/selfdrag");
require("xe-utils");
var _vxeTable = _interopRequireDefault(require("vxe-table"));
var _vxeTablePluginExportXlsx = _interopRequireDefault(require("vxe-table-plugin-export-xlsx"));
require("vxe-table/lib/style.css");
var _vxeTablePluginElement = _interopRequireDefault(require("vxe-table-plugin-element"));
require("vxe-table-plugin-element/dist/style.css");
var _sortablejs = _interopRequireDefault(require("sortablejs"));
var _ckeditor5Vue = _interopRequireDefault(require("@ckeditor/ckeditor5-vue2"));
var _vuePrintNb = _interopRequireDefault(require("vue-print-nb"));
var _socket = require("socket.io-client");
var _antDesignVue = require("ant-design-vue");
require("ant-design-vue/dist/antd.css");
var _lodash = _interopRequireDefault(require("lodash"));
var _vueI18n = _interopRequireDefault(require("vue-i18n"));
var _zh = _interopRequireDefault(require("@/languages/zh/zh.js"));
var _en = _interopRequireDefault(require("@/languages/en/en.js"));
var _jsBase = require("js-base64");
/*
 * @Author: lingeng
 * @LastEditTime: 2022-10-24 14:55:45
 * @Email: 971213720@qq.com
 * @Company: 可待科技
 */

// a modern alternative to CSS resets

require('@/components/index');
var randomColor = require('randomcolor');
_vue.default.prototype.randomColor = randomColor;

// global css
// ruoyi css
// margin padding css
// flex css

// icon
// permission control

// plugins
_vue.default.use(_plugins.default);
// 引入移动事件（el-drag-dialog.js的内容为上面的代码块）
_vue.default.directive('el-drag-dialog', _elDragDialog.default); //添加标签事件绑定 可以放大移动弹窗

// 导入自定义指令
//弹窗默认点击遮罩改为不关闭 为了防止和拖拽冲突 ，这句需要放在use ElementUI之前（也可以不加这句，自己测试区别）
_elementUi.default.Dialog.props.closeOnClickModal.default = false;
// 全局方法挂载
_vue.default.prototype.moment = _moment.default;
_vue.default.prototype.getDicts = _data.getDicts;
_vue.default.prototype.getConfigKey = _config.getConfigKey;
_vue.default.prototype.parseTime = _ruoyi2.parseTime;
_vue.default.prototype.resetForm = _ruoyi2.resetForm;
_vue.default.prototype.addDateRange = _ruoyi2.addDateRange;
_vue.default.prototype.selectDictLabel = _ruoyi2.selectDictLabel;
_vue.default.prototype.download = _ruoyi2.download;
_vue.default.prototype.handleTree = _ruoyi2.handleTree;
_vue.default.prototype.$XPrint = _vxeTable.default.print;
_vue.default.prototype.Download = _downloadjs.default;
_vue.default.use(_vxeTable.default);
_vxeTable.default.use(_vxeTablePluginExportXlsx.default);
_vxeTable.default.use(_vxeTablePluginElement.default);
_vue.default.prototype.$Sortable = _sortablejs.default;
_vue.default.use(_ckeditor5Vue.default);
_vue.default.use(_vuePrintNb.default);
_vue.default.prototype.$socket = (0, _socket.io)('https://socket.dianzhangbao.com.cn:2345', {
  transports: ['websocket']
});
_vue.default.use(_vueElementUtils.default);
_vue.default.prototype.msgSuccess = function (msg) {
  this.$message.obj({
    showClose: true,
    message: msg,
    type: "success"
  });
};
_vue.default.prototype.msgError = function (msg) {
  this.$message.obj({
    showClose: true,
    message: msg,
    type: "error"
  });
};
_vue.default.prototype.msgInfo = function (msg) {
  this.$message.info(msg);
};
_vue.default.prototype.$tableStorage = {
  storage: {
    visible: true,
    resizable: true
  } //是否启用 localStorage 本地保存，会将列操作状态保留在本地（需要有 id）
};

// 全局组件挂载
_vue.default.component('Pagination', _Pagination.default);
_vue.default.use(_permission.default);
_vue.default.use(_antDesignVue.Cascader);
_vue.default.use(_antDesignVue.Statistic);
_vue.default.use(_antDesignVue.Row);
_vue.default.use(_antDesignVue.Col);
//lodash

_vue.default.prototype._ = _lodash.default;
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */

// 终端类型
var WIDTH = 992;
var rect = document.body.getBoundingClientRect();
_vue.default.prototype.isMobile = rect.width - 1 < WIDTH;

// i18n

_vue.default.use(_vueI18n.default); // 通过插件的形式挂载
var i18n = new _vueI18n.default({
  locale: 'zh',
  // 定义默认语言为中文 
  messages: {
    'zh': _zh.default,
    'en': _en.default
  }
});

// base64

_vue.default.prototype.$Base64 = _jsBase.Base64;

// 事件总线
_vue.default.prototype.$bus = new _vue.default();
_vue.default.use(_elementUi.default, {
  size: _jsCookie.default.get('size') || 'medium' // set element-ui default size
});

_vue.default.config.productionTip = false;
_router.default.beforeEach(function (to, from, next) {
  /* 路由发生变化修改页面meta */
  if (to.meta.content) {
    var head = document.getElementsByTagName('head');
    var meta = document.createElement('meta');
    meta.content = to.meta.content;
    head[0].appendChild(meta);
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = "".concat(to.meta.title, "\u2014\u2014\u5E97\u638C\u5B9DERP");
  }
  next();
});
_vue.default.prototype.$common = function () {
  alert('开发中...');
};
new _vue.default({
  el: '#app',
  i18n: i18n,
  router: _router.default,
  store: _store.default,
  render: function render(h) {
    return h(_App.default);
  }
});
_vue.default.prototype.convertCurrency = function (money) {
  //汉字的数字
  var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
  //基本单位
  var cnIntRadice = new Array('', '拾', '佰', '仟');
  //对应整数部分扩展单位
  var cnIntUnits = new Array('', '万', '亿', '兆');
  //对应小数部分单位
  var cnDecUnits = new Array('角', '分', '毫', '厘');
  //整数金额时后面跟的字符
  var cnInteger = '整';
  //整型完以后的单位
  var cnIntLast = '元';
  //最大处理的数字
  var maxNum = 999999999999999.9999;
  //金额整数部分
  var integerNum;
  //金额小数部分
  var decimalNum;
  //输出的中文金额字符串
  var chineseStr = '';
  //分离金额后用的数组，预定义
  var parts;
  if (money == '') {
    return '';
  }
  money = parseFloat(money);
  if (money >= maxNum) {
    //超出最大处理数字
    return '';
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  //转换为字符串
  money = money.toString();
  if (money.indexOf('.') == -1) {
    integerNum = money;
    decimalNum = '';
  } else {
    parts = money.split('.');
    integerNum = parts[0];
    decimalNum = parts[1].substr(0, 4);
  }
  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    var zeroCount = 0;
    var IntLen = integerNum.length;
    for (var i = 0; i < IntLen; i++) {
      var n = integerNum.substr(i, 1);
      var p = IntLen - i - 1;
      var q = p / 4;
      var m = p % 4;
      if (n == '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        //归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  //小数部分
  if (decimalNum != '') {
    var decLen = decimalNum.length;
    for (var i = 0; i < decLen; i++) {
      var n = decimalNum.substr(i, 1);
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '') {
    chineseStr += cnInteger;
  }
  return chineseStr;
};
_vue.default.prototype.cleanObj = function (obj) {
  var priorityList = ['make_invoice_img', 'pay_voucher'];
  Object.keys(obj).forEach(function (key) {
    if (obj[key] === undefined || obj[key] === '') {
      !priorityList.includes(key) && delete obj[key];
    }
  });
  var arrayKeys = [];
  for (var key in obj) {
    if (obj[key] instanceof Array && key != 'custom') {
      obj[key] = encodeURIComponent(JSON.stringify(obj[key]));
      arrayKeys.push(key);
    }
  }
  if (arrayKeys.length > 0) {
    obj.arrayKeys = arrayKeys.join(',');
  }
  return obj;
};

/*
* 转换如下来自后台不规范的数组
* {0:'http://***.***.***.png',1:'http://***.***.***.png',2:'http://***.***.***.png'}
* return Array
*/
_vue.default.prototype.$transformUnstandardArray = function (unStandardArray) {
  var newArray = _lodash.default.cloneDeep(unStandardArray);
  if (Object.keys(unStandardArray).length < 1) {
    return [];
  } else {
    newArray.length = Object.keys(unStandardArray).length;
    return Array.from(newArray);
  }
};
_vue.default.prototype.gridOptions2 = {
  toolbarConfig: {
    export: _store.default.state.settings.enableExport,
    zoom: true,
    custom: true,
    slots: {
      buttons: 'toolbar_buttons'
    }
  },
  checkboxConfig: {
    reserve: true,
    highlight: true,
    range: true,
    fixed: "left"
  }
  // exportConfig: {
  //   remote: false,
  //   types: ['xlsx'],
  //   modes: ['current', 'selected', 'all']
  // },
};

_vue.default.prototype.$uploadAction = process.env.VUE_APP_BASE_API + "StockPart/upload";
_vue.default.prototype.$uploadHeader = {
  "x-auth-token": (0, _auth.getToken)(),
  "Access-Token": "YJGzmoKjkwGFsUeUAVxbFWHWTsxOMugA"
};

// 导入element-ui
/**
  * 重写ELementUI的Message
  * single默认值true，因为项目需求，默认只弹出一个，可以根据实际需要设置
*/
var DonMessage = /*#__PURE__*/function () {
  function DonMessage() {
    (0, _classCallCheck2.default)(this, DonMessage);
  }
  (0, _createClass2.default)(DonMessage, [{
    key: "success",
    value: function success(options) {
      var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.showMessage('success', options, single);
    }
  }, {
    key: "info",
    value: function info(options) {
      var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.showMessage('info', options, single);
    }
  }, {
    key: "error",
    value: function error(options) {
      var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.showMessage('error', options, single);
    }
  }, {
    key: "warning",
    value: function warning(options) {
      var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.showMessage('warning', options, single);
    }
  }, {
    key: "obj",
    value: function obj(options) {
      var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      _elementUi.Message.closeAll();
      (0, _elementUi.Message)(Object.assign(options, {
        showClose: true
      }));
    }
  }, {
    key: "showMessage",
    value: function showMessage(type, options, single) {
      var obj = options;
      if (typeof obj == 'string') {
        if (single) {
          // console.dir(Message)
          // 这个是Message属性
          _elementUi.Message.closeAll();
          _elementUi.Message[type]({
            message: options,
            showClose: true
          });
        } else {
          _elementUi.Message.closeAll();
          _elementUi.Message[type]({
            message: options,
            showClose: true
          });
        }
      } else {
        _elementUi.Message.closeAll();
        (0, _elementUi.Message)(Object.assign(options, {
          showClose: true
        }));
      }
    }
  }]);
  return DonMessage;
}();
_vue.default.prototype.$message = new DonMessage();
_vue.default.prototype.$Emessage = _elementUi.Message;
function changeURLStatic(name, value) {
  var url = location.href;
  var reg = eval('/([\?|&]' + name + '=)[^&]*/gi');
  value = value.toString().replace(/(^\s*)|(\s*$)/g, ""); //移除首尾空格
  if (!value) {
    var url2 = url.replace(reg, ''); //正则替换
  } else {
    if (url.match(reg)) {
      var url2 = url.replace(reg, '$1' + value); //正则替换
    } else {
      var url2 = url + (url.indexOf('?') > -1 ? '&' : '?') + name + '=' + value; //没有参数添加参数
    }
  }

  history.replaceState(null, null, url2); //替换地址栏
}

_vue.default.prototype.$delUrlParam = function (key) {
  var url = key;
  var baseUrl = url.split('?')[0] + '?';
  var query = url.split('?')[1];
  if (query.indexOf(key) > -1) {
    var obj = {};
    var arr = query.split('&');
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split('=');
      obj[arr[i][0]] = arr[i][1];
    }
    delete obj[key];
    var _url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, '').replace(/\:/g, '=').replace(/\,/g, '&');
    return _url;
  } else {
    return url;
  }
};

// 将列表自定义字段数组值转为,拼接
_vue.default.prototype.$joinStr = function (list, fieldData) {
  list.forEach(function (item) {
    fieldData.map(function (itemF) {
      var arr = [];
      try {
        arr = JSON.parse(item[itemF.field]);
        item[itemF.field] = arr.join(',');
      } catch (err) {
        item[itemF.field] = item[itemF.field];
      }
    });
  });
  return list;
};

// 处理带有颜色的业务字段的值
_vue.default.prototype.$showValue = function (list) {
  var value = [];
  list.forEach(function (item) {
    var arr = item.split('*');
    value.push(arr[0]);
  });
  return value;
};
_vue.default.prototype.$showColor = function (list) {
  var color = {};
  list.forEach(function (item) {
    var arr = item.split('*');
    color[arr[0]] = arr[1];
  });
  return color;
};